import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vShow as _vShow } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "form-title" }, [
    /*#__PURE__*/ _createElementVNode("h2", null, "\r\n\t\t\t\t\tAlarms\r\n\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_4 = { class: "form-menu visible-sm" };
const _hoisted_5 = { class: "float-end" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-search" }, null, -1 /* HOISTED */);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Search", -1 /* HOISTED */);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-refresh" }, null, -1 /* HOISTED */);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Clear", -1 /* HOISTED */);
const _hoisted_10 = { class: "form-contents" };
const _hoisted_11 = { class: "row" };
const _hoisted_12 = { class: "clearfix" };
const _hoisted_13 = { class: "col-xs-12 col-sm-12 col-md-10 no-padding" };
const _hoisted_14 = { class: "clearfix" };
const _hoisted_15 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-3"
};
const _hoisted_16 = { class: "input-group top_search" };
const _hoisted_17 = { class: "input-group top_search" };
const _hoisted_18 = { class: "input-group top_search" };
const _hoisted_19 = { class: "input-group top_search" };
const _hoisted_20 = { class: "clearfix" };
const _hoisted_21 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_22 = { class: "input-group top_search" };
const _hoisted_23 = { key: 0 };
const _hoisted_24 = {
    key: 0,
    class: "multiselect__single"
};
const _hoisted_25 = ["onClick"];
const _hoisted_26 = { class: "font-weight-normal" };
const _hoisted_27 = { class: "col-xs-12 col-sm-12 col-md-2" };
const _hoisted_28 = { class: "input-group top_search" };
const _hoisted_29 = { class: "col-xs-12 col-sm-12 col-md-2" };
const _hoisted_30 = { class: "input-group top_search" };
const _hoisted_31 = { class: "col-xs-12 col-sm-12 col-md-5" };
const _hoisted_32 = {
    key: 0,
    class: "btn-group pw100"
};
const _hoisted_33 = {
    key: 1,
    class: "row left-10 right-10"
};
const _hoisted_34 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_35 = /*#__PURE__*/ _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
    /*#__PURE__*/ _createElementVNode("button", {
        type: "button",
        class: "btn btn-default",
        "data-toggle": ""
    }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" })
    ])
], -1 /* HOISTED */);
const _hoisted_36 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_37 = /*#__PURE__*/ _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
    /*#__PURE__*/ _createElementVNode("button", {
        type: "button",
        class: "btn btn-default",
        "data-toggle": ""
    }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" })
    ])
], -1 /* HOISTED */);
const _hoisted_38 = { class: "col-xs-12 col-sm-12 col-md-2 hidden-sm" };
const _hoisted_39 = { class: "float-start pw100" };
const _hoisted_40 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-search" }, null, -1 /* HOISTED */);
const _hoisted_41 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Search", -1 /* HOISTED */);
const _hoisted_42 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-refresh" }, null, -1 /* HOISTED */);
const _hoisted_43 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Clear", -1 /* HOISTED */);
const _hoisted_44 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix top10" }, null, -1 /* HOISTED */);
const _hoisted_45 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12"
};
const _hoisted_46 = { class: "clearfix data-grid-top-pagination" };
const _hoisted_47 = { class: "float-end left5" };
const _hoisted_48 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-cog" }, null, -1 /* HOISTED */);
const _hoisted_49 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix" }, [
    /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tColumn visibility\r\n\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_50 = { class: "clearfix pad10" };
const _hoisted_51 = { class: "float-end" };
const _hoisted_52 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
const _hoisted_53 = {
    key: 0,
    class: "float-end"
};
const _hoisted_54 = { class: "float-start" };
const _hoisted_55 = /*#__PURE__*/ _createElementVNode("i", {
    class: "fa fa-check",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
const _hoisted_56 = /*#__PURE__*/ _createElementVNode("i", {
    class: "fa fa-commenting",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
const _hoisted_57 = /*#__PURE__*/ _createElementVNode("i", {
    class: "fa fa-arrow-down",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
const _hoisted_58 = /*#__PURE__*/ _createElementVNode("i", {
    class: "fa fa-arrow-down",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
const _hoisted_59 = { class: "float-end hidden-xs record-count" };
const _hoisted_60 = {
    key: 1,
    class: "col-xs-12 col-sm-12"
};
const _hoisted_61 = { class: "card bg-white data-grid alarm-grid detached overflow-x-auto" };
const _hoisted_62 = {
    id: "alarmTable",
    class: "table table-hover bottom0 border-collapse-separate"
};
const _hoisted_63 = { class: "alarm-border selection-column" };
const _hoisted_64 = {
    key: 0,
    class: "icon-column"
};
const _hoisted_65 = {
    key: 1,
    class: "date-time-column"
};
const _hoisted_66 = {
    key: 2,
    class: "hidden-sm"
};
const _hoisted_67 = {
    key: 3,
    class: "hidden-sm"
};
const _hoisted_68 = {
    key: 4,
    class: "icon-column"
};
const _hoisted_69 = {
    key: 5,
    class: "hidden-sm icon-column"
};
const _hoisted_70 = {
    key: 6,
    class: "hidden-sm"
};
const _hoisted_71 = {
    key: 7,
    class: "hidden-sm"
};
const _hoisted_72 = {
    key: 8,
    class: "hidden-sm"
};
const _hoisted_73 = {
    key: 9,
    class: "hidden-sm"
};
const _hoisted_74 = {
    key: 10,
    class: "hidden-sm text-end"
};
const _hoisted_75 = { class: "selection-column" };
const _hoisted_76 = {
    key: 0,
    class: "icon-column"
};
const _hoisted_77 = ["onClick"];
const _hoisted_78 = /*#__PURE__*/ _createElementVNode("i", {
    class: "fa fa-commenting",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
const _hoisted_79 = [
    _hoisted_78
];
const _hoisted_80 = ["onClick"];
const _hoisted_81 = /*#__PURE__*/ _createElementVNode("i", {
    class: "fa fa-exclamation",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
const _hoisted_82 = [
    _hoisted_81
];
const _hoisted_83 = { key: 1 };
const _hoisted_84 = { class: "hidden-sm" };
const _hoisted_85 = { class: "clearfix visible-sm" };
const _hoisted_86 = { class: "blue lead" };
const _hoisted_87 = { class: "clearfix" };
const _hoisted_88 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-clock-o" }, null, -1 /* HOISTED */);
const _hoisted_89 = { class: "clearfix" };
const _hoisted_90 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-exclamation-triangle" }, null, -1 /* HOISTED */);
const _hoisted_91 = { class: "clearfix" };
const _hoisted_92 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-server" }, null, -1 /* HOISTED */);
const _hoisted_93 = { class: "clearfix" };
const _hoisted_94 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-map-marker" }, null, -1 /* HOISTED */);
const _hoisted_95 = {
    key: 2,
    class: "hidden-sm"
};
const _hoisted_96 = {
    key: 3,
    class: "hidden-sm"
};
const _hoisted_97 = ["title"];
const _hoisted_98 = {
    key: 0,
    class: "fa fa-check",
    "aria-hidden": "true"
};
const _hoisted_99 = {
    key: 5,
    class: "hidden-sm"
};
const _hoisted_100 = { key: 0 };
const _hoisted_101 = /*#__PURE__*/ _createElementVNode("i", {
    class: "fa fa-share",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
const _hoisted_102 = {
    key: 6,
    class: "hidden-sm"
};
const _hoisted_103 = ["onClick"];
const _hoisted_104 = {
    key: 7,
    class: "hidden-sm"
};
const _hoisted_105 = ["onClick"];
const _hoisted_106 = {
    key: 8,
    class: "hidden-sm"
};
const _hoisted_107 = {
    key: 9,
    class: "hidden-sm text-end"
};
const _hoisted_108 = ["onClick", "title"];
const _hoisted_109 = {
    key: 10,
    class: "hidden-sm"
};
const _hoisted_110 = { key: 0 };
const _hoisted_111 = /*#__PURE__*/ _createElementVNode("td", {
    class: "text-center hidden-sm",
    colspan: "13"
}, [
    /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_112 = /*#__PURE__*/ _createElementVNode("td", { class: "text-center visible-sm" }, [
    /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_113 = { class: "clearfix" };
const _hoisted_114 = { class: "x_panel" };
const _hoisted_115 = { class: "x_content" };
const _hoisted_116 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_117 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\tDate/Time to clear the selected alarms\r\n\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_118 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" }, null, -1 /* HOISTED */);
const _hoisted_119 = { class: "float-end float-start-sm" };
const _hoisted_120 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* HOISTED */);
const _hoisted_121 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_flat_pickr = _resolveComponent("flat-pickr");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    const _component_b_form_group = _resolveComponent("b-form-group");
    const _component_b_dropdown_form = _resolveComponent("b-dropdown-form");
    const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_router_link = _resolveComponent("router-link");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    const _component_AlarmCommentsVue = _resolveComponent("AlarmCommentsVue");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_modal = _resolveComponent("b-modal");
    const _directive_standard_or_higher = _resolveDirective("standard-or-higher");
    const _directive_b_tooltip = _resolveDirective("b-tooltip");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_b_button, {
                        variant: "primary",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.search(true, true))),
                        disabled: _ctx.working
                    }, {
                        default: _withCtx(() => [
                            _hoisted_6,
                            _hoisted_7
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["disabled"]),
                    _createTextVNode(),
                    _createVNode(_component_b_button, {
                        variant: "primary",
                        onClick: _ctx.resetFilters,
                        disabled: _ctx.working
                    }, {
                        default: _withCtx(() => [
                            _hoisted_8,
                            _hoisted_9
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick", "disabled"])
                ])
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                            (_ctx.showCompanySelect)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                        _createVNode(_component_multiselect, {
                                            modelValue: _ctx.company,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.company) = $event)),
                                            options: _ctx.companies,
                                            "track-by": "value",
                                            label: "text",
                                            showLabels: false,
                                            placeholder: "All company",
                                            class: "multiselect-small"
                                        }, {
                                            noResult: _withCtx(() => [
                                                _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t")
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["modelValue", "options"])
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createTextVNode(),
                            _createElementVNode("div", {
                                class: _normalizeClass(['col-xs-12', 'col-sm-12', _ctx.showCompanySelect ? 'col-md-3' : 'col-md-4'])
                            }, [
                                _createElementVNode("div", _hoisted_17, [
                                    _createVNode(_component_multiselect, {
                                        id: "systemFilter",
                                        name: "system",
                                        modelValue: _ctx.system,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.system) = $event)),
                                        options: _ctx.filteredSystems,
                                        "track-by": "systemId",
                                        label: "displayName",
                                        showLabels: false,
                                        placeholder: "Any system",
                                        class: "multiselect-small",
                                        disabled: _ctx.working
                                    }, {
                                        noResult: _withCtx(() => [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue", "options", "disabled"])
                                ])
                            ], 2 /* CLASS */),
                            _createTextVNode(),
                            _createElementVNode("div", {
                                class: _normalizeClass(['col-xs-12', 'col-sm-12', _ctx.showCompanySelect ? 'col-md-3' : 'col-md-4'])
                            }, [
                                _createElementVNode("div", _hoisted_18, [
                                    _createVNode(_component_multiselect, {
                                        id: "siteFilter",
                                        modelValue: _ctx.site,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.site) = $event)),
                                        options: _ctx.filteredSites,
                                        "track-by": "value",
                                        label: "text",
                                        showLabels: false,
                                        placeholder: "Any site",
                                        class: "multiselect-small",
                                        disabled: _ctx.working
                                    }, {
                                        noResult: _withCtx(() => [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue", "options", "disabled"])
                                ])
                            ], 2 /* CLASS */),
                            _createTextVNode(),
                            _createElementVNode("div", {
                                class: _normalizeClass(['col-xs-12', 'col-sm-12', _ctx.showCompanySelect ? 'col-md-3' : 'col-md-4'])
                            }, [
                                _createElementVNode("div", _hoisted_19, [
                                    _createVNode(_component_multiselect, {
                                        id: "alarmTypeFilter",
                                        name: "alarmType",
                                        modelValue: _ctx.alarmType,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.alarmType) = $event)),
                                        options: _ctx.alarmTypes,
                                        "track-by": "value",
                                        label: "text",
                                        showLabels: false,
                                        placeholder: "Any alarm type",
                                        class: "multiselect-small",
                                        disabled: _ctx.working
                                    }, {
                                        noResult: _withCtx(() => [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue", "options", "disabled"])
                                ])
                            ], 2 /* CLASS */)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, [
                                    _createVNode(_component_multiselect, {
                                        ref: "alarmSeverityOptions",
                                        id: "alarmSeverityFilter",
                                        name: "alarmSeverityOptions",
                                        options: _ctx.alarmSeverities,
                                        multiple: true,
                                        showLabels: false,
                                        preserveSearch: true,
                                        closeOnSelect: false,
                                        placeholder: "",
                                        "track-by": "value",
                                        label: "text",
                                        class: "multiselect-small",
                                        disabled: _ctx.working
                                    }, {
                                        noResult: _withCtx(() => [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t")
                                        ]),
                                        placeholder: _withCtx(() => [
                                            (!_ctx.numberOfSeletedAlarmSeverities)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_23, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tNone selected\r\n\t\t\t\t\t\t\t\t\t\t\t"))
                                                : _createCommentVNode("v-if", true)
                                        ]),
                                        selection: _withCtx(({ search, isOpen }) => [
                                            (_ctx.numberOfSeletedAlarmSeverities && !isOpen)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.alarmSeverityOptionText), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true)
                                        ]),
                                        option: _withCtx((props) => [
                                            _createElementVNode("div", {
                                                onClick: _withModifiers(($event) => (_ctx.selectSeverity(props.option)), ["stop"])
                                            }, [
                                                (_openBlock(), _createBlock(_component_b_form_checkbox, {
                                                    id: 'severity-' + props.option.value,
                                                    checked: props.option.selected,
                                                    key: _ctx.getAlarmSeverityFilter(props.option)
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("label", _hoisted_26, _toDisplayString(props.option.text), 1 /* TEXT */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "checked"]))
                                            ], 8 /* PROPS */, _hoisted_25)
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["options", "disabled"])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                    _createVNode(_component_multiselect, {
                                        id: "alarmStateFilter",
                                        name: "alarmState",
                                        modelValue: _ctx.alarmState,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.alarmState) = $event)),
                                        options: _ctx.alarmStates,
                                        "track-by": "value",
                                        label: "text",
                                        showLabels: false,
                                        placeholder: "Any alarm state",
                                        class: "multiselect-small",
                                        disabled: _ctx.working
                                    }, {
                                        noResult: _withCtx(() => [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue", "options", "disabled"])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_29, [
                                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_30, [
                                    _createVNode(_component_multiselect, {
                                        id: "acknowledgeStatusFilter",
                                        name: "acknowledgeStatus",
                                        modelValue: _ctx.acknowledgeStatus,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.acknowledgeStatus) = $event)),
                                        options: _ctx.acknowledgeStatuses,
                                        "track-by": "value",
                                        label: "text",
                                        showLabels: false,
                                        placeholder: "Any alarm status",
                                        class: "multiselect-small",
                                        disabled: _ctx.working
                                    }, {
                                        noResult: _withCtx(() => [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue", "options", "disabled"])
                                ])), [
                                    [_directive_standard_or_higher]
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_31, [
                                (!_ctx.showDatePickers)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateFilterOptions, (item, idx) => {
                                            return _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                                                class: "pw100",
                                                disabled: _ctx.working,
                                                key: idx,
                                                variant: _ctx.dateFilterOption == item ? 'primary' : 'outline-secondary',
                                                onClick: ($event) => (_ctx.setDateFilterOption(item)),
                                                title: _ctx.getPeriodTitle(item)
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(item), 1 /* TEXT */)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled", "variant", "onClick", "title"])), [
                                                [
                                                    _directive_b_tooltip,
                                                    void 0,
                                                    void 0,
                                                    { hover: true }
                                                ]
                                            ]);
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                _createTextVNode(),
                                (_ctx.showDatePickers)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                        _createElementVNode("div", _hoisted_34, [
                                            _createVNode(_component_b_input_group, {
                                                class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.startDateInvalid ? 'is-invalid' : ''])
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_flat_pickr, {
                                                        class: "form-control",
                                                        modelValue: _ctx.query.startTime,
                                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.query.startTime) = $event)),
                                                        config: _ctx.datePickerConfig,
                                                        placeholder: "From date",
                                                        disabled: _ctx.working
                                                    }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                                    _createTextVNode(),
                                                    _createVNode(_component_b_input_group_append, null, {
                                                        default: _withCtx(() => [
                                                            _hoisted_35
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    })
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["class"])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_36, [
                                            _createVNode(_component_b_input_group, {
                                                class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.endDateInvalid ? 'is-invalid' : ''])
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_flat_pickr, {
                                                        class: "form-control",
                                                        modelValue: _ctx.query.endTime,
                                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.query.endTime) = $event)),
                                                        config: _ctx.datePickerConfig,
                                                        placeholder: "Until date",
                                                        disabled: _ctx.working
                                                    }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                                    _createTextVNode(),
                                                    _createVNode(_component_b_input_group_append, null, {
                                                        default: _withCtx(() => [
                                                            _hoisted_37,
                                                            _createTextVNode(),
                                                            _createElementVNode("button", {
                                                                type: "button",
                                                                class: "btn btn-default btn-secondary",
                                                                onClick: _cache[9] || (_cache[9] =
                                                                    //@ts-ignore
                                                                    (...args) => (_ctx.resetDateFilterOption && _ctx.resetDateFilterOption(...args)))
                                                            }, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t...\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    })
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["class"])
                                        ])
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                            _createVNode(_component_b_button, {
                                variant: "primary pw100 bottom10",
                                onClick: _cache[10] || (_cache[10] = ($event) => (_ctx.search(true, true)))
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_40,
                                    _hoisted_41
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createTextVNode(),
                            _createVNode(_component_b_button, {
                                variant: "primary pw100",
                                onClick: _ctx.resetFilters
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_42,
                                    _hoisted_43
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"])
                        ])
                    ])
                ]),
                _createTextVNode(),
                _hoisted_44,
                _createTextVNode(),
                (_ctx.searchAttempted)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, [
                                _createVNode(_component_b_dropdown, {
                                    ref: "columnSettingsDropdown",
                                    "no-caret": "",
                                    end: "",
                                    sm: "",
                                    "auto-close": false,
                                    variant: "outline-secondary outline-secondary-pagination",
                                    disabled: _ctx.working
                                }, {
                                    "button-content": _withCtx(() => [
                                        _hoisted_48
                                    ]),
                                    default: _withCtx(() => [
                                        _createTextVNode(),
                                        _createVNode(_component_b_dropdown_form, { class: "column-settings-dropdown" }, {
                                            default: _withCtx(() => [
                                                _hoisted_49,
                                                _createTextVNode(),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, columnIdx) => {
                                                    return (_openBlock(), _createBlock(_component_b_form_group, {
                                                        key: column.fieldName
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_b_form_group, null, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_b_form_checkbox, {
                                                                        id: column.fieldName,
                                                                        modelValue: column.visible,
                                                                        "onUpdate:modelValue": ($event) => ((column.visible) = $event)
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(column.title), 1 /* TEXT */)
                                                                        ]),
                                                                        _: 2 /* DYNAMIC */
                                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "modelValue", "onUpdate:modelValue"])
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1024 /* DYNAMIC_SLOTS */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1024 /* DYNAMIC_SLOTS */));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ]),
                                            _: 1 /* STABLE */
                                        }),
                                        _createTextVNode(),
                                        _createVNode(_component_b_dropdown_divider),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_50, [
                                            _createElementVNode("div", _hoisted_51, [
                                                _createVNode(_component_b_button, {
                                                    variant: "secondary",
                                                    right: "",
                                                    sm: "",
                                                    onClick: _ctx.closeColumnSettingsMenu
                                                }, {
                                                    default: _withCtx(() => [
                                                        _hoisted_52,
                                                        _createTextVNode(" Close\r\n\t\t\t\t\t\t\t\t\t\t")
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["onClick"])
                                            ])
                                        ])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["disabled"])
                            ]),
                            _createTextVNode(),
                            (_ctx.numberOfVisibleColumns)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                    _createVNode(_component_b_pagination, {
                                        class: "float-end",
                                        modelValue: _ctx.query.pageNo,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.query.pageNo) = $event)),
                                        "per-page": _ctx.query.pageSize,
                                        "total-rows": _ctx.data.recordCount,
                                        "hide-ellipsis": true,
                                        disabled: _ctx.working
                                    }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_54, [
                                _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                                    "variant-": "secondary",
                                    disabled: _ctx.acknowledgeButtonDisabled(),
                                    onClick: _ctx.acknowledgeSelectedAlarms
                                }, {
                                    default: _withCtx(() => [
                                        _hoisted_55,
                                        _createTextVNode(" Acknowledge\r\n\t\t\t\t\t\t\t")
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["disabled", "onClick"])), [
                                    [_directive_standard_or_higher]
                                ]),
                                _createTextVNode(),
                                _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                                    "variant-": "secondary",
                                    disabled: _ctx.commentButtonDisabled(),
                                    onClick: _ctx.showComments
                                }, {
                                    default: _withCtx(() => [
                                        _hoisted_56,
                                        _createTextVNode(" Comments\r\n\t\t\t\t\t\t\t")
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["disabled", "onClick"])), [
                                    [_directive_standard_or_higher]
                                ]),
                                _createTextVNode(),
                                _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                                    "variant-": "secondary",
                                    disabled: _ctx.createIssueDisabled(),
                                    onClick: _ctx.createIssue
                                }, {
                                    default: _withCtx(() => [
                                        _hoisted_57,
                                        _createTextVNode(" Create an Issue\r\n\t\t\t\t\t\t\t")
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["disabled", "onClick"])), [
                                    [_directive_standard_or_higher]
                                ]),
                                _createTextVNode(),
                                (_ctx.clearVisible())
                                    ? (_openBlock(), _createBlock(_component_b_button, {
                                        key: 0,
                                        "variant-": "secondary",
                                        disabled: _ctx.clearDisabled(),
                                        onClick: _ctx.showClearAlarms
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_58,
                                            _createTextVNode(" Clear\r\n\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["disabled", "onClick"]))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_59, "\r\n\t\t\t\t\t\t\tItems: " + _toDisplayString(_ctx.data.recordCount), 1 /* TEXT */)
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                _createTextVNode(),
                (_ctx.numberOfVisibleColumns)
                    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                            _createElementVNode("table", _hoisted_62, [
                                _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                        _createElementVNode("th", _hoisted_63, [
                                            _createVNode(_component_b_form_checkbox, {
                                                size: "sm",
                                                modelValue: _ctx.selectAll,
                                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.selectAll) = $event))
                                            }, null, 8 /* PROPS */, ["modelValue"])
                                        ]),
                                        _createTextVNode(),
                                        (_ctx.isVisible('notes'))
                                            ? _withDirectives((_openBlock(), _createElementBlock("th", _hoisted_64, [
                                                _createCommentVNode("<i class=\"fa fa-commenting \" aria-hidden=\"true\"></i>")
                                            ])), [
                                                [_directive_standard_or_higher]
                                            ])
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('whenRaised'))
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_65, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'WhenRaised', title: 'Time', visible: true }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('duration'))
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_66, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'Duration', title: 'Duration' }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('state'))
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_67, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'State', title: 'State' }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('acknowledged'))
                                            ? _withDirectives((_openBlock(), _createElementBlock("th", _hoisted_68, [
                                                _createCommentVNode("<i class=\"fa fa-check\" aria-hidden=\"true\"></i>")
                                            ])), [
                                                [_directive_standard_or_higher]
                                            ])
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('alarmEvent'))
                                            ? _withDirectives((_openBlock(), _createElementBlock("th", _hoisted_69, [
                                                _createCommentVNode("<i class=\"fa fa-share\" aria-hidden=\"true\"></i>")
                                            ])), [
                                                [_directive_standard_or_higher]
                                            ])
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('systemName'))
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_70, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'SystemName', title: 'System' }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('componentName'))
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_71, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'ComponentName', title: 'Location' }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('alarmDefinitionName'))
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_72, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'AlarmDefinitionName', title: 'Description' }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('minValue'))
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_73, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'ExtremeValue', title: 'Value' }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('siteName'))
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_74, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'SiteName', title: 'Site' }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                            class: _normalizeClass(['alarm', _ctx.alarmClass(item)])
                                        }, [
                                            _createElementVNode("td", _hoisted_75, [
                                                _createVNode(_component_b_form_checkbox, {
                                                    size: "sm",
                                                    modelValue: item.selected,
                                                    "onUpdate:modelValue": ($event) => ((item.selected) = $event),
                                                    onClick: (event) => _ctx.onSelection(item.alarmId, event)
                                                }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "onClick"])
                                            ]),
                                            _createTextVNode(),
                                            (_ctx.isVisible('notes'))
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_76, [
                                                    (item.hasNotes)
                                                        ? (_openBlock(), _createElementBlock("span", {
                                                            key: 0,
                                                            class: "pointer",
                                                            onClick: ($event) => (_ctx.showCommentsForAlarm(item))
                                                        }, _hoisted_79, 8 /* PROPS */, _hoisted_77))
                                                        : _createCommentVNode("v-if", true),
                                                    _createTextVNode(),
                                                    (_ctx.hasIssues(item))
                                                        ? (_openBlock(), _createElementBlock("span", {
                                                            key: 1,
                                                            class: "pointer",
                                                            onClick: ($event) => (_ctx.goToIssue(item))
                                                        }, _hoisted_82, 8 /* PROPS */, _hoisted_80))
                                                        : _createCommentVNode("v-if", true)
                                                ]))
                                                : _createCommentVNode("v-if", true),
                                            _createTextVNode(),
                                            (_ctx.isVisible('whenRaised'))
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_83, [
                                                    _createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.whenRaisedTimeString(item)), 1 /* TEXT */),
                                                    _createTextVNode(),
                                                    _createElementVNode("div", _hoisted_85, [
                                                        _createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.whenRaisedTimeString(item)), 1 /* TEXT */),
                                                        _createTextVNode(),
                                                        _createElementVNode("div", _hoisted_87, [
                                                            _hoisted_88,
                                                            _createTextVNode("  " + _toDisplayString(item.duration), 1 /* TEXT */)
                                                        ]),
                                                        _createTextVNode(),
                                                        _createElementVNode("div", _hoisted_89, [
                                                            _hoisted_90,
                                                            _createTextVNode(" " + _toDisplayString(item.alarmDefinitionName) + " (" + _toDisplayString(item.minValue || 'N/A') + ")\r\n\t\t\t\t\t\t\t\t\t\t\t", 1 /* TEXT */)
                                                        ]),
                                                        _createTextVNode(),
                                                        _createElementVNode("div", _hoisted_91, [
                                                            _hoisted_92,
                                                            _createTextVNode(" " + _toDisplayString(item.componentName) + " | " + _toDisplayString(item.systemName), 1 /* TEXT */)
                                                        ]),
                                                        _createTextVNode(),
                                                        _createElementVNode("div", _hoisted_93, [
                                                            _hoisted_94,
                                                            _createTextVNode(" " + _toDisplayString(item.siteName), 1 /* TEXT */)
                                                        ])
                                                    ])
                                                ]))
                                                : _createCommentVNode("v-if", true),
                                            _createTextVNode(),
                                            (_ctx.isVisible('duration'))
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_95, _toDisplayString(item.duration), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true),
                                            _createTextVNode(),
                                            (_ctx.isVisible('state'))
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_96, _toDisplayString(_ctx.getAlarmState(item)), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true),
                                            _createTextVNode(),
                                            (_ctx.isVisible('acknowledged'))
                                                ? (_openBlock(), _createElementBlock("td", {
                                                    key: 4,
                                                    class: "icon-column hidden-sm",
                                                    title: _ctx.getAcknowledgeTitle(item)
                                                }, [
                                                    (_ctx.isAcknowledged(item))
                                                        ? (_openBlock(), _createElementBlock("i", _hoisted_98))
                                                        : _createCommentVNode("v-if", true)
                                                ], 8 /* PROPS */, _hoisted_97))
                                                : _createCommentVNode("v-if", true),
                                            _createTextVNode(),
                                            (_ctx.isVisible('alarmEvent'))
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_99, [
                                                    (item.alarmEventId)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_100, [
                                                            _createVNode(_component_router_link, {
                                                                to: { name: 'events', params: { 'eventId': item.alarmEventId } },
                                                                class: "blue"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _hoisted_101
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                                        ]))
                                                        : _createCommentVNode("v-if", true)
                                                ]))
                                                : _createCommentVNode("v-if", true),
                                            _createTextVNode(),
                                            (_ctx.isVisible('systemName'))
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_102, [
                                                    _createElementVNode("span", {
                                                        class: "pointer blue",
                                                        onClick: ($event) => (_ctx.goToSystemSnapshot(item, $event))
                                                    }, _toDisplayString(item.systemName), 9 /* TEXT, PROPS */, _hoisted_103)
                                                ]))
                                                : _createCommentVNode("v-if", true),
                                            _createTextVNode(),
                                            (_ctx.isVisible('componentName'))
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_104, [
                                                    _createElementVNode("span", {
                                                        class: "pointer blue",
                                                        onClick: ($event) => (_ctx.goToSnapshot(item, $event))
                                                    }, _toDisplayString(item.componentName), 9 /* TEXT, PROPS */, _hoisted_105)
                                                ]))
                                                : _createCommentVNode("v-if", true),
                                            _createTextVNode(),
                                            (_ctx.isVisible('alarmDefinitionName'))
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_106, _toDisplayString(item.alarmDefinitionName), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true),
                                            _createTextVNode(),
                                            (_ctx.isVisible('minValue'))
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_107, [
                                                    _withDirectives((_openBlock(), _createElementBlock("span", {
                                                        class: _normalizeClass([{ 'pointer blue': !_ctx.isErrorAlarm(item) }, { 'alarm-error-code': _ctx.isErrorAlarm(item) }]),
                                                        onClick: ($event) => (!_ctx.isErrorAlarm(item) ? _ctx.goToTrend(item, $event) : null),
                                                        title: _ctx.isErrorAlarm(item) ? _ctx.getErrorCodeTooltip(item) : 'Click to view trend'
                                                    }, [
                                                        _createTextVNode(_toDisplayString(_ctx.getAlarmValue(item)), 1 /* TEXT */)
                                                    ], 10 /* CLASS, PROPS */, _hoisted_108)), [
                                                        [
                                                            _directive_b_tooltip,
                                                            void 0,
                                                            void 0,
                                                            { hover: true }
                                                        ]
                                                    ])
                                                ]))
                                                : _createCommentVNode("v-if", true),
                                            _createTextVNode(),
                                            (_ctx.isVisible('siteName'))
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_109, _toDisplayString(item.siteName), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true)
                                        ], 2 /* CLASS */));
                                    }), 256 /* UNKEYED_FRAGMENT */))
                                ]),
                                _createTextVNode(),
                                _createElementVNode("tfoot", null, [
                                    (_ctx.noData)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_110, [
                                            _hoisted_111,
                                            _createTextVNode(),
                                            _hoisted_112
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ])
                        ])
                    ], 512 /* NEED_PATCH */)), [
                        [_vShow, _ctx.searchAttempted]
                    ])
                    : _createCommentVNode("v-if", true)
            ])
        ]),
        _createTextVNode(),
        _createVNode(_component_StatusOverlayComponent, {
            visible: _ctx.loading,
            message: "Loading..."
        }, null, 8 /* PROPS */, ["visible"]),
        _createTextVNode(),
        _createVNode(_component_AlarmCommentsVue, {
            modelValue: _ctx.showAlarmCommentsModal,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.showAlarmCommentsModal) = $event)),
            alarmIds: _ctx.getSelectedAlarmIds(),
            componentId: _ctx.getSelectedAlarmComponentId(),
            systemId: _ctx.getSystemIdSelected(),
            onOnReload: _ctx.reload
        }, null, 8 /* PROPS */, ["modelValue", "alarmIds", "componentId", "systemId", "onOnReload"]),
        _createTextVNode(),
        _createVNode(_component_b_modal, {
            id: "clear-alarms-modal",
            modelValue: _ctx.showClearAlarmsModal,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.showClearAlarmsModal) = $event)),
            "header-bg-variant": "normal",
            size: "md"
        }, {
            title: _withCtx(() => [
                _createTextVNode("\r\n\t\t\t\tClear Alarms\r\n\t\t\t")
            ]),
            footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_119, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "primary",
                        onClick: _ctx.clearAlarms
                    }, {
                        default: _withCtx(() => [
                            _hoisted_120,
                            _createTextVNode(" Clear\r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]),
                    _createTextVNode(),
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "secondary",
                        onClick: _ctx.closeClearAlarmsModal
                    }, {
                        default: _withCtx(() => [
                            _hoisted_121,
                            _createTextVNode(" Cancel\r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])
            ]),
            default: _withCtx(() => [
                _createTextVNode(),
                _createVNode(_component_b_container, { clearfix: "" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_113, [
                            _createElementVNode("div", _hoisted_114, [
                                _createElementVNode("div", _hoisted_115, [
                                    _createElementVNode("div", _hoisted_116, [
                                        _hoisted_117,
                                        _createTextVNode(),
                                        _createVNode(_component_b_input_group, { class: "clearfix bottom0" }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_flat_pickr, {
                                                    modelValue: _ctx.dateTimeToClearAlarms,
                                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.dateTimeToClearAlarms) = $event)),
                                                    class: "form-control",
                                                    config: _ctx.datePickerConfig
                                                }, null, 8 /* PROPS */, ["modelValue", "config"]),
                                                _createTextVNode(),
                                                _createVNode(_component_b_input_group_append, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_b_button, {
                                                            type: "button",
                                                            variant: "outline-secondary",
                                                            "data-toggle": ""
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _hoisted_118
                                                            ]),
                                                            _: 1 /* STABLE */
                                                        })
                                                    ]),
                                                    _: 1 /* STABLE */
                                                })
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }),
                _createTextVNode()
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"])
    ]));
}
